import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import logo from "@/assets/logo.png";

const SiteFooter = forwardRef<HTMLElement>((_, ref) => {
  return (
    <footer ref={ref} className="bg-secondary text-secondary-foreground">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <img src={logo} alt="ShashiSun Energy" className="h-14 mb-4" width={84} height={56} loading="lazy" />
            <p className="text-secondary-foreground/60 text-sm leading-relaxed max-w-xs">
              Jaipur's trusted rooftop solar panel installation company. Powering homes and businesses with clean energy since 2025.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Services & Pricing", path: "/services" },
                { label: "Our Projects", path: "/gallery" },
                { label: "Contact Us", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Contact Us</h3>
            <div className="space-y-4">
              <a href="tel:9145863773" className="flex items-center gap-3 text-sm text-secondary-foreground/60 hover:text-primary transition-colors">
                <Phone className="h-4 w-4 text-primary shrink-0" />
                +91 91458 63773
              </a>
              <a href="tel:9784558338" className="flex items-center gap-3 text-sm text-secondary-foreground/60 hover:text-primary transition-colors">
                <Phone className="h-4 w-4 text-primary shrink-0" />
                +91 97845 58338
              </a>
              <a href="mailto:Nikchoudhary0909@gmail.com" className="flex items-center gap-3 text-sm text-secondary-foreground/60 hover:text-primary transition-colors">
                <Mail className="h-4 w-4 text-primary shrink-0" />
                Nikchoudhary0909@gmail.com
              </a>
              <div className="flex items-start gap-3 text-sm text-secondary-foreground/60">
                <MapPin className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                301, 3rd Floor, P. No. 8, near VPM Classes, B Yojna, Radha Kunj, Mansarovar, Jaipur, Rajasthan 302020
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-foreground/10 mt-12 pt-8 text-center">
          <p className="text-xs text-secondary-foreground/60">
            © {new Date().getFullYear()} ShashiSun Energy Pvt Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
});

SiteFooter.displayName = "SiteFooter";

export default SiteFooter;
